module.exports = __webpack_public_path__ + "static/media/ends.feb7fa8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/Icons/assets/paste/ends.svg
// module id = ./src/assets/Mozilla/DesignTokens/Icons/assets/paste/ends.svg
// module chunks = 0